import { SEO } from './components/SEO'
import { LandingPage } from './components/LandingPage'
import { LegalPage } from './components/LegalPage'

function App() {
  const path = window.location.pathname.replace(/\/$/, '') || '/'
  if (path === '/privacy') return <LegalPage kind="privacy" />
  if (path === '/terms') return <LegalPage kind="terms" />

  return (
    <>
      <SEO
        title="AgentWhisper, voice dictation that stays on your Mac"
        description="Hit a shortcut, speak, and your words land at the cursor in any Mac app. Local Whisper transcription, Apple Intelligence compatible, your own AI keys for cleanup. One-time purchase, $19.99 launch price, normally $79."
        image="https://agentwhisper.altuzar.dev/og.png"
        url="https://agentwhisper.altuzar.dev/"
      />
      <LandingPage />
    </>
  )
}

export default App
